import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskService} from '../../services/task.service';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
  selector: 'nf-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  @Input() boardData: any = {}; // 面板数据
  @Output() getUserData: EventEmitter<any> = new EventEmitter<any>();
  @Input('userData') set userDataChange(data) {
    if (data) {
      this.receiver = data;
      if (this.receiver['type'] === 'person' && this.receiver['labels']) {
        this.userSelectedList = this.receiver['labels'];
      }
      if (this.receiver['type'] == 'column') {
        this.tabIndex = 1;
      }
      if (this.receiver['type'] === 'boardSubscriber') {
        this.tabIndex = 2;
      }
    }
  }
  boardId;
  selectedMemberValue;
  randomUserUrl;
  total: number;
  pageIndex = 1;
  pageSize = 10;
  getBoardUserList: Observable<any>;
  memberList: Array<any> = []; // 待选成员列表
  isLoading = false;
  loadMoreData = true;
  boardColumnData;
  userSelectedList = [];
  userColumnList = [];
  tabIndex = 0;
  params = {
    page: 1,
    size: 20,
    searchKey: ''
  };

  receiver = {};
  checkAll = false;
  subscribers = [];
  constructor(
    private taskService: TaskService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    if (this.boardData) {
      this.boardId = this.boardData.id;
      this.taskService.getBoardSubscribers(this.boardId, {}).subscribe(res => {
        if (res && res.data) {
          this.subscribers = res.data || [];
          if (this.receiver['value']) {
            for (let item of this.subscribers) {
              item.checked = this.receiver['value'].includes(item.id);
            }
          }
        }
      });
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      if (this.boardColumnData && this.boardColumnData.length > 0) {
        for (const column of this.boardColumnData) {
          if (column.type === 'multiple-person') {
            this.userColumnList.push(column);
          }
        }
      }
      this.loadMore();
    }
  }

  // 下拉加载更多
  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.memberList = [...this.memberList, ...newData];
          if (this.pageIndex === data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }

  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardId, param).subscribe((res: any) => {
      if (res) {
        this.memberList = res.users ? res.users.data : [];
        this.isLoading = false;
      }
    });
  }

  userTabIndexChange() {
    this.receiver['value'] = [];
    this.receiver['labels'] = [];
    this.userSelectedList = [];
    if (this.tabIndex == 0) {
      this.receiver['type'] = 'person';
    } else if (this.tabIndex == 1) {
      this.receiver['type'] = 'column';
    } else {
      this.receiver['type'] = 'boardSubscriber';
      for (let item of this.subscribers) {
        item.checked = false;
      }
    }
    this.getUserData.emit(this.receiver);
  }

  userColumnChange(item) {
    if (!item) {
      return;
    }
    if (this.tabIndex == 0) {
      this.receiver['type'] = 'person';
    } else if (this.tabIndex == 1) {
      this.receiver['type'] = 'column';
    }
    if (!this.receiver['value']) {
      this.receiver['value'] = [];
    }
    if (!this.receiver['value'].includes(item.id)) {
      this.receiver['value'].push(item.id);
      this.userSelectedList.push(item);
    }
    this.receiver['labels'] = this.userSelectedList;
    this.getUserData.emit(this.receiver);
  }

  removeUser(id) {
    let index = this.receiver['value'].indexOf(id);
    this.receiver['value'].splice(index, 1);
    if (this.receiver['value'].length === 0) {
      this.receiver = {};
    }
    index = this.userSelectedList.findIndex(user => user.id === id);
    this.userSelectedList.splice(index, 1);
  }

  checkAllChange() {
    this.receiver['value'] = [];
    this.receiver['labels'] = [];
    if (this.checkAll) {
      for (let item of this.subscribers) {
        item.checked = true;
        this.receiver['value'].push(item.id);
        this.receiver['labels'].push(item);
      }
    } else {
      for (let item of this.subscribers) {
        item.checked = false;
      }
    }
    this.getUserData.emit(this.receiver);
  }

  checkboxChange() {
    this.receiver['value'] = [];
    this.receiver['labels'] = [];
    let flag = true;
    for (let item of this.subscribers) {
      flag = flag && item.checked;
      if (item.checked) {
        this.receiver['value'].push(item.id);
        this.receiver['labels'].push(item);
      }
    }
    this.checkAll = flag;
    this.getUserData.emit(this.receiver);
  }
}
